import React, {useEffect} from 'react'

import useEvaluations from '../../hooks/useEvaluations'
import Page from '../../components/Page'
import ItemLoader, {RendererProps} from '../../components/ItemLoader'
import CurrentConnections from '../../components/connections/Current'
import ConnectModels from '../../components/connections/ConnectModels'
import {EvaluationFilters} from '../../components/filters'
import type {Model as ModelType} from '../../services/types'

const RenderModelConnections = ({item: model, setItem}: RendererProps<ModelType>) => {
  const {refresh, getItems} = useEvaluations()
  useEffect(
    () =>
      refresh({
        filters: {
          model: model.id,
          fields: [
            'name',
            'description',
            'next_run',
            'modalities',
            'task_types',
            'min_questions_to_complete',
            'tags',
            'price',
          ],
        },
      }),
    [model.id, refresh]
  )
  return (
    <Page title={`Evaluate ${model.name}`} showTitle>
      <CurrentConnections item={model} itemsType="evaluation" />
      <ConnectModels
        item={model}
        itemType="model"
        itemsGetter={getItems}
        searchOptions={{
          searchLabel: 'filter evaluations',
          sortLabel: 'Sort evaluations:',
          sortOptions: {
            nameAsc: 'By name (asc)',
            nameDesc: 'By name (desc)',
          },
          filtersElem: EvaluationFilters,
        }}
      />
    </Page>
  )
}

const ModelConnections: React.FC = () => (
  <ItemLoader itemName="model" renderer={RenderModelConnections} />
)
export default ModelConnections
